
import { defineComponent, PropType } from "vue";
// import EventBusService from "@/services/EventBusService";
// import RegionProducts from "@/components/RegionProducts.vue";
import { UserProfile } from "@/data/profile";
import AuthService from "@/services/AuthService";
import NavigationService from "@/services/NavigationService";
import { getError } from "@/utils/helpers";
import TextField from "@/components/forms/TextField.vue";
import FieldError from "@/components/forms/FieldError.vue";
import EventBusService from "@/services/EventBusService";

type Form = {
    email: string,
    phone_mobile: string,
    consent_newsletter: boolean,
};

type FormErrors = Record<string, string[]>;

declare interface ProfileEditModalData {
    loading: boolean,
    shownLocal: boolean,

    form: Form,

    errors: FormErrors
}

export default defineComponent({
    name: 'ProfileEditModal',
    components: {
        FieldError,
        TextField
        // RegionProducts,
    },
    emits: [
        'updated',
        'close',
    ],
    props: {
        profile: {
            type: [Object] as PropType<UserProfile>,
            required: false,
            default: null,
        },
        shown: {
            type: Boolean,
            required: true,
        },
    },
    data(): ProfileEditModalData {
        return {
            loading: false,
            shownLocal: true,
            form: {
                email: '',
                phone_mobile: '',
                consent_newsletter: false,
            },
            errors: {},
        };
    },
    computed: {
        hasErrors() {
            return Object.keys(this.errors).length > 0;
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        submitForm() {
            if( this.loading ) {
                return;
            }

            this.errors = {};
            this.loading = true;
            AuthService.updateUser(this.form).then((resp) => {
                // this.loading = false; // we do not do this in success case because we are redirecting the user (better UX)

                console.log(resp);

                this.$emit('updated', this.form);
                this.closeModal();

                EventBusService.$notification({
                    type: 'success',
                    message: 'Deine persönlichen Daten wurden aktualisiert.',
                });

                // this.success = true;
                // this.errors = {};

            }).catch(error => {
                //console.warn(error);
                //console.warn(getError(error));
                this.errors = getError(error);
            }).finally(() => this.loading = false);
        }
    },
    watch: {
        shown: {
            handler(val) {
                this.shownLocal = val;
            },
            immediate: true,
        },
        profile: {
            handler(val) {
                if( !val ) {
                    return;
                }

                this.form.email = val.email || '';
                this.form.phone_mobile = val.phone_mobile || '';
                this.form.consent_newsletter = val.consent_newsletter || '';
            },
            immediate: true,
        },
    },
    mounted() {
        /*this.$watch('shown', (newShown: boolean) => {
            if( newShown ) {
                console.log('tmp SHOW MODAL RegionProductsModal');
            }
        });*/
        // EventBusService.$on('user.credits:changed', this.onUserCreditChanged);
    },
    beforeUnmount() {
        // EventBusService.$off('user.credits:changed', this.onUserCreditChanged);
    }
});
